import styled from "styled-components";

export const MessageError = styled.p`
    font-size: 13px;
    color: red;

    margin-bottom: 5px;
`;

export const LabelContainer = styled.div`
    position: absolute;
    margin-left: 41px;
    margin-bottom: 45px;
    background-color: white;
    height: 15px;
    font-size: 15px;
    color: #234e52;
    z-index: 10;
`;

export const Container = styled.div`
    padding: 8px;
    display: flex;
    align-items: center;
    width: 100%;
`;

export const IconContainer = styled.div`
    color: #234e52;
    margin-right: 16px;
`;
